import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

export default function Error({ error, code, text, historylink }) {
  const history = useHistory();

  if (code === 401) {
    localStorage.removeItem("jwtHeader");
    toast.error(
      "Oturumunuzun süresi dolmuş. Lütfen tekrar giriş işlemi yapınız."
    );
    history.push(historylink);
  }

  return (
    <>
      <div className="w-full h-[calc(100vh-130px)] flex items-center justify-center self-center text-center object-center">
        <section className="flex items-center h-full p-16  ">
          <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
            <div className="max-w-md text-center w-96">
              <h2 className="mb-8 font-extrabold text-9xl 0">
                {!!code ? code : "404"}
              </h2>
              <p className="text-2xl font-semibold md:text-3xl">
                {!!error ? error : "Aradığınız sayfa bulunamadı."}
              </p>
              <p className="mt-4 mb-8 ">
                Açmaya çalıştığınız sayfaya ulaşamadık.İsterseniz giriş ekranına
                geri dönebilirsiniz.
              </p>
              <button
                onClick={() => history.push(historylink)}
                className="btn px-8 py-3 font-semibold rounded cursor-pointer "
              >
                {text}
              </button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
